import { OPEN_TOASTER, CLOSE_TOASTER } from 'constants/actionTypes';

const defaultState = {};

function toasterReducer(state = defaultState, action) {
  switch (action.type) {
    case OPEN_TOASTER:
      return {
        ...state,
        [action.payload.key]: action.payload,
      };
    case CLOSE_TOASTER:
      const newState = { ...state };
      delete newState[action.payload];

      return newState;
    default:
      return state;
  }
}

export default toasterReducer;
